import React from 'react';
import { animated, useSpring } from 'react-spring';
import { easeCubicInOut } from 'd3-ease';
import { animationEnabled } from '../../utils/GetGlobalAnimations';
import { useMeasure } from '../../hooks/useMeasure';

interface SlideProps {
  open: boolean;
  duration?: number;
  children: any;
  direction?: 'horizontal' | 'vertical';
  style?: React.CSSProperties;
  animationStyle?: React.CSSProperties;
}

export const Slide: React.FC<React.PropsWithChildren<SlideProps>> = ({
  open,
  duration = 100,
  direction = 'vertical',
  style: styleProp,
  animationStyle,
  children
}) => {
  const [{ ref }, { height, width }] = useMeasure();
  const properties: React.CSSProperties =
    direction === 'vertical' ? { height: open ? height : 0 } : { width: open ? width : 0 };

  const style = useSpring({
    ...properties,
    opacity: open ? 1 : 0,
    overflow: 'hidden',
    immediate: !animationEnabled(),
    config: {
      duration,
      easing: easeCubicInOut
    }
  });
  return (
    <animated.div style={{ ...style, ...animationStyle }}>
      <span style={{ display: 'inline-block', ...styleProp }} ref={ref}>
        {children}
      </span>
    </animated.div>
  );
};
